/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
// material
// content
import { ReactComponent as CommentIcon } from 'assets/icons/comment.svg'
import { ReactComponent as CaretDown } from 'assets/icons/caret-down.svg'
import { ReactComponent as EmojiAdd } from 'assets/icons/emoji-add.svg'
import { ReactComponent as ImageAdd } from 'assets/icons/image.svg'
import { ReactComponent as GifAdd } from 'assets/icons/gif.svg'
import { ReactComponent as VideoAdd } from 'assets/icons/video.svg'
import { ReactComponent as TextFormat } from 'assets/icons/text-format.svg'
import { ReactComponent as ReplyCaret } from 'assets/icons/chevron-down.svg'
import PreviewConfig from '../../previewconfig/previewconfig'
// styles
import injectSheet from 'react-jss'
import styles from './themepreview_styles'
import Space from 'material/space/space'
import Avatar from '../components/avatar/avatar'
import UserBadge from '../components/userbadge/userbadge'
import EmojiReaction from '../components/emojireaction/emojireaction'
import { isLight } from 'utils/theme'
import { themePreview } from 'utils/consts/language'

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : THEME PREVIEW ~~~~~~~~~~ ========== */
const ThemePreview = injectSheet(styles)((props) => {

  const { siteTheme, themeColors } = props
  const { tempDisplayConfig: { emojis }, tempDisplayConfig, tempCommentingUnitConfig: { generalConfig } } = useSelector(state => state.commentingV2)

  const isDarkMode = useMemo(() => !isLight(siteTheme.customBackgroundColor), [siteTheme])

  const themePreviewLanguage = themePreview[siteTheme.language || 'EN']

  return (
    <div className={`themepreview ${props.classes.themepreview}`}>
      <PreviewConfig title={'Theme Preview'}>
        <Space klass={'commentsheader'} flexWrap={'wrap'} justifiyContent={'space-between'}>
          <Space alignItems={'flex-start'}>
            <CommentIcon className='icons neutral' /><h1>{generalConfig.headerTitle}<span className='commentscount'>124</span></h1>
          </Space>
          <div className={'sortdropdown'}>
            <span>{themePreviewLanguage.mostRecent}</span>
            <CaretDown className='icons neutral' />
          </div>
        </Space>
        <Space justifiyContent={'space-between'}>
          <Space alignItems={'center'}>
            <Avatar name={`${siteTheme.avatarPack || 'DEFAULT'}_1`} extension={siteTheme.themeExtension|| 'DEFAULT'} />
            <h3>LightininHopkins</h3>
            <UserBadge 
              themeColors={themeColors}
              name={'TOP_COMMENTER'} 
              language={siteTheme.language}
              style={siteTheme.userBadgeStyle || 'COLORFUL'} 
              isDark={isDarkMode}
              backgroundColor={themeColors.backgroundSecondary}  
              extension={siteTheme.themeExtension || 'DEFAULT'} 
            />          
          </Space>
        </Space>
        <Space klass={'commentbox'} alignItems={'flex-start'} direction={'column'}>
          <div className={'commenttextarea'}>
            <h1>{themePreviewLanguage.joinConversation}</h1>
          </div>
          <Space alignItems={'center'} justifiyContent={'space-between'}>
            <Space klass={'commentrichmedia'} alignItems={'center'}>
              <EmojiAdd />
              <ImageAdd />
              <GifAdd />
              <VideoAdd />
              <TextFormat />
            </Space>
            <div className='postbutton button'>{themePreviewLanguage.post}</div>
          </Space>
        </Space>

        <Space gap={0} direction={'column'}>
          <Space alignItems={'center'}>
            <Avatar name={`${siteTheme.avatarPack || 'DEFAULT'}_3`} extension={siteTheme.themeExtension || 'DEFAULT'} />
            <h3>WillieDixon</h3>
            <UserBadge 
              themeColors={themeColors}
              name={'RISING_STAR'} 
              language={siteTheme.language}
              style={siteTheme.userBadgeStyle || 'COLORFUL'} 
              isDark={isDarkMode}
              backgroundColor={themeColors.backgroundSecondary}  
              extension={siteTheme.themeExtension || 'DEFAULT'} 
            />          </Space>
          <div className={'commentwrapper'}>
            <p>{themePreviewLanguage.comment1}</p>
            <Space klass={'commentfooter'} alignItems={'center'}>
              <div className='button'>{themePreviewLanguage.reply}</div>
              <EmojiAdd className='icons neutral' />
              { emojis && emojis.map((emoji, index) => {
                if(emoji) {
                  const emojiName = emoji.emojiCategory.emojiName
                  const isActive = emoji.active
                  const count =  index + 1
                  if(isActive) return <EmojiReaction size={siteTheme.fontSize} themeColors={themeColors} name={emojiName} darkMode={isDarkMode} type={siteTheme.emojiCategoryType || tempDisplayConfig.emojiCategoryType} count={count} />
                }})
              }
              <span className='postedtime'>{themePreviewLanguage.minutes}</span>
            </Space>
          </div>
        </Space>


        <Space gap={0} direction={'column'}>
          <Space alignItems={'center'}>
            <Avatar name={`${siteTheme.avatarPack || 'DEFAULT'}_5`} extension={siteTheme.themeExtension || 'DEFAULT'} />
            <ReplyCaret className='replycaret' />

            <h3>AgnesVarda</h3>
            <UserBadge 
              themeColors={themeColors}
              name={'LEGEND'} 
              language={siteTheme.language}
              style={siteTheme.userBadgeStyle || 'COLORFUL'} 
              isDark={isDarkMode}
              backgroundColor={themeColors.backgroundSecondary}  
              extension={siteTheme.themeExtension || 'DEFAULT'} 
            />
          </Space>
          <div className={'commentwrapper hasreply'}>
            <div>
              <p>{themePreviewLanguage.comment2}</p>
              <Space klass={'commentfooter'} alignItems={'center'}>
                <div className='button'>{themePreviewLanguage.reply}</div>
                <Space gap={4} alignItems={'center'}>
                  <CommentIcon className='icons neutral' />
                  <span className='reply'>1 {themePreviewLanguage.reply}</span>
                  <EmojiAdd className='icons neutral' />
                  <EmojiReaction size={siteTheme.fontSize} themeColors={themeColors} darkMode={isDarkMode} name={'LIKE'} type={siteTheme.emojiCategoryType || tempDisplayConfig.emojiCategoryType} count={5} />
                  <EmojiReaction size={siteTheme.fontSize} themeColors={themeColors} darkMode={isDarkMode} name={'THOUGHTFUL'} type={siteTheme.emojiCategoryType || tempDisplayConfig.emojiCategoryType} count={12} />
                  <span className='postedtime'>{themePreviewLanguage.minutes}</span>
                </Space>
              </Space>
            </div>
      
            <Space gap={0} direction={'column'}>
              <Space alignItems={'center'}>
                <Avatar name={`${siteTheme.avatarPack || 'DEFAULT'}_6`} extension={siteTheme.themeExtension || 'DEFAULT'} />
                <h3>HowlinWolf</h3>
                <UserBadge
                  themeColors={themeColors} 
                  name={'CONVERSATION_STARTER'} 
                  language={siteTheme.language}
                  style={siteTheme.userBadgeStyle || 'COLORFUL'} 
                  isDark={isDarkMode}
                  backgroundColor={themeColors.backgroundSecondary}  
                  extension={siteTheme.themeExtension || 'DEFAULT'} 
                />
              </Space>
              <div className={'commentwrapper'}>
                <p>{themePreviewLanguage.comment3}</p>
                <Space klass={'commentfooter'} alignItems={'center'}>
                  <div className='button'>{themePreviewLanguage.reply}</div>
                  <Space gap={4} alignItems={'center'}>
                    <EmojiAdd className='icons neutral' />
                    <EmojiReaction size={siteTheme.fontSize} themeColors={themeColors} name={'SAD'} darkMode={isDarkMode} type={siteTheme.emojiCategoryType || tempDisplayConfig.emojiCategoryType} count={6} />
                    <span className='postedtime'>{themePreviewLanguage.minutes}</span>
                  </Space>
                </Space>
              </div>
            </Space>

          </div>
        </Space>

      </PreviewConfig>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ThemePreview